module.exports = __webpack_public_path__ + "img/tire.da8d8c1a.svg";